import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../icons/icon'

const OptionGroup = props => {
  const { items, name, style } = props
  const options = items.map((item, i) => {
    const radioId = `option-${name}-${i}`
    const { label, icon, value, checked, disabled, handleChange } = item
    return (
      <div className={'option-field'} key={i}>
        <input
          id={radioId}
          checked={checked}
          type='radio'
          name={name}
          value={value || label}
          onChange={handleChange}
          disabled={disabled}
        />
        <label className='option-label' htmlFor={radioId}>
          <Icon name={icon} />
          <span className='text'>{label}</span>
        </label>
      </div>
    )
  })
  return (
    <div className='option-group' style={style}>
      {options}
    </div>
  )
}

OptionGroup.propTypes = {
  name: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string,
      value: PropTypes.string,
      checked: PropTypes.bool,
      handleChange: PropTypes.func,
      disabled: PropTypes.bool
    })
  ),
  style: PropTypes.string
}

export default OptionGroup



// WEBPACK FOOTER //
// ./src/ui/forms/option-group.js